/**
 * Reusable Card container
 *
 * Usage:
 *   <Card>Content here</Card>
 *   <Card padding="lg" hover>Hoverable card with large padding</Card>
 */

const PADDING = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-5 sm:p-6',
};

export default function Card({
  children,
  padding = 'md',
  hover = false,
  className = '',
  onClick,
  ...props
}) {
  return (
    <div
      className={[
        'bg-white rounded-xl border border-slate-100 transition-all duration-200',
        PADDING[padding],
        hover && 'hover:shadow-card hover:border-slate-200 cursor-pointer',
        onClick && 'cursor-pointer',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
}

Card.displayName = 'Card';
export { Card };
